import styled from 'styled-components';

export const Main = styled.div`
    display: flex;
    height: 100%;
    column-gap: 4px;
`;

export const UpperTooltip = styled.sup<{ isVisible?: boolean }>`
    display: ${({ isVisible = true }) => (isVisible ? 'flex' : 'none')};
    font-size: 10px;
    text-align: start;
    align-self: flex-start;
    line-height: 12px;
    padding: 0;
    margin: 0;
`;
